module.exports = __webpack_public_path__ + "img/six-senses-rome_0.9eef0099.jpg";